import { Map, List } from "immutable";
import {
  AUTHORIZE_LINK_VALIDATE_SUCCESSFUL,
  AUTHORIZE_PASSCODE_VALIDATE_SUCCESSFUL,
  AUTHORIZE_PAANS_CHECK_SUCCESSFUL,
  AUTHORIZE_PASSCODE_ACTION_DATA_SUCCESSFUL,
  AUTHORIZE_LINK_ACTION_DATA_SUCCESSFUL,
  AUTHORIZE_LINK_ACTION_DETAIL_SUCCESSFUL,
  GO_LINK_SUCCESSFUL,
  GO_LINK_ERROR,
  AUTHORIZE_LINK_VALIDATE_ERROR,
  AUTHORIZE_PASSCODE_VALIDATE_ERROR,
  AUTHORIZE_PAANS_CHECK_ERROR,
  AUTHORIZE_PASSCODE_ACTION_DATA_ERROR,
  AUTHORIZE_LINK_ACTION_DATA_ERROR,
  AUTHORIZE_LINK_ACTION_DETAIL_ERROR,
  AUTHORIZE_LINK_ENUM_ACTION_TYPE_SUCCESSFUL,
  AUTHORIZE_LINK_ENUM_ACTION_TYPE_ERROR,
  AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_SUCCESSFUL,
  AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_ERROR,
  AUTHORIZE_LINK_UPDATE_STATUS,
  AUTHORIZE_LINK_LINKS_EXPIRE_SUCCESSFUL,
  AUTHORIZE_GET_CONFIRMATION_STATUS_SUCCESSFUL,
  AUTHORIZE_GET_CONFIRMATION_STATUS_ERROR,
  AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE_SUCCESSFUL,
  AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE_ERROR,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_ERROR
} from "./constants/actionTypes";

const InitialState = {
  actionData: new Map(),
  validLink: new Map(),
  validPassCode: new Map(),
  sendPassCodeRes: new Map(),
  paansStatus: new Map(),
  actionTypes: new List(),
  actionValidations: new List(),
  magicLink: new Map(),
  status: 0,
  linkIsExpired: false,
  confirmationIsCompleted: false,
  requestIsActive: "true",
  settings: { language: "en", applicationName: "ARIA" }
};
const actionAuthorizationReducer = (state = Map(InitialState), action) => {
  switch (action.type) {
    case AUTHORIZE_LINK_VALIDATE_SUCCESSFUL:
      return state.set("validLink", Map(action.payload));
    case AUTHORIZE_PASSCODE_VALIDATE_SUCCESSFUL:
      return state.set("validPassCode", Map(action.payload));
    case AUTHORIZE_PASSCODE_ACTION_DATA_SUCCESSFUL:
      return state.set("sendPassCodeRes", Map(action.payload));
    case AUTHORIZE_PAANS_CHECK_SUCCESSFUL:
      return state.set("paansStatus", Map(action.payload));
    case AUTHORIZE_LINK_ACTION_DATA_SUCCESSFUL:
      return state.set("actionData", Map(action.payload));
    case AUTHORIZE_LINK_ACTION_DETAIL_SUCCESSFUL:
      return state.set("actionDetail", Map(action.payload));
    case AUTHORIZE_LINK_ENUM_ACTION_TYPE_SUCCESSFUL:
      return state.set("actionTypes", List(action.payload));
    case AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_SUCCESSFUL:
      return state.set("actionValidations", List(action.payload));
    case AUTHORIZE_LINK_UPDATE_STATUS:
      return state.set("status", action.payload);
    case AUTHORIZE_LINK_LINKS_EXPIRE_SUCCESSFUL:
      return state.set("linkIsExpired", "true");
    case GO_LINK_SUCCESSFUL:
      return state.set("magicLink", Map(action.payload));
    case AUTHORIZE_GET_CONFIRMATION_STATUS_SUCCESSFUL:
      return state.set("confirmationIsCompleted", action.payload);
    case AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE_SUCCESSFUL:
      return state.set("requestIsActive", action.payload.toString());
    case GET_SETTINGS_SUCCESS:
      return state.set("settings", action.payload);
    default:
      return state;
  }
};
const InitialStateError = {
  errors: List()
};
const errorAuthorizationReducer = (state = Map(InitialStateError), action) => {
  const errors = state.get("errors");
  const newErrors = errors.push(
    `Error occurs on action: '${action.type}', message: '${action.payload}'`
  );
  switch (action.type) {
    case AUTHORIZE_LINK_VALIDATE_ERROR:
    case AUTHORIZE_PASSCODE_VALIDATE_ERROR:
    case AUTHORIZE_PASSCODE_ACTION_DATA_ERROR:
    case AUTHORIZE_PAANS_CHECK_ERROR:
    case AUTHORIZE_LINK_ACTION_DATA_ERROR:
    case AUTHORIZE_LINK_ACTION_DETAIL_ERROR:
    case AUTHORIZE_LINK_ENUM_ACTION_TYPE_ERROR:
    case AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_ERROR:
    case AUTHORIZE_GET_CONFIRMATION_STATUS_ERROR:
    case AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE_ERROR:
    case GO_LINK_ERROR:
    case GET_SETTINGS_ERROR:
      return state.set("errors", newErrors);
    default:
      return state;
  }
};
const authorizeLinkReducer = {
  actionAuthorizationReducer: actionAuthorizationReducer,
  errorAuthorizationReducer: errorAuthorizationReducer
};
export default authorizeLinkReducer;
